import { config } from '@facet-wealth/design';

if (process.env.REACT_APP_STAGE !== 'prod') {
  config.setWrapZodInExtraCatch(false); // We want the original error to bubble up, not the error we're creating above
  config.setValidationErrorHandler(({ title: _title, info, sensitiveInfo } = {}) => {
    const title = `Invalid FD prop: ${_title}`;
    // eslint-disable-next-line no-console
    console.error(title, { ...info, ...sensitiveInfo });
    // If you're stuck on this debugger, your page is about to unplug - see what's rendering this component and adjust the props it gets!
    // eslint-disable-next-line no-debugger
    debugger;

    // Sometimes there's a better title but it contains sensitive info - use it if available, since this is in dev
    const err = new Error(sensitiveInfo?.title ?? title);
    err.name = title;
    err.details = { ...info, ...sensitiveInfo };

    throw err;
  });
} else {
  config.setWrapZodInExtraCatch(true);
  config.setValidationErrorHandler(({ title, info } = {}) => {
    // In prod, do not give away any sensitive info in the error
    // eslint-disable-next-line no-console
    console.error(`Invalid FD prop: ${title}`, info);
  });
}
